import { render, staticRenderFns } from "./FigureList.vue?vue&type=template&id=42d4642c&"
import script from "./FigureList.vue?vue&type=script&lang=js&"
export * from "./FigureList.vue?vue&type=script&lang=js&"
import style0 from "./FigureList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports